/**
 * @title Constants
 * @notice All constants used throughout the SDK
 */

/**
 * Tick Lens related constants
 */
export const TICK_BITMAP_INDEX = {
  MIN: -32768,
  MAX: 32767
} as const;
